import { Button, ButtonProps } from "@mantine/core";
import React from "react";

export const FormSubmitButton = (props: ButtonProps) => {
  return <Button type="submit" color="primary" {...props} />;
};
